/** Open EMS UI base (override via REACT_APP_OPEN_EMS_UI_URL for non-prod hosts). */
export const OPEN_EMS_UI_URL =
  (typeof process !== 'undefined' &&
    process.env.REACT_APP_OPEN_EMS_UI_URL &&
    String(process.env.REACT_APP_OPEN_EMS_UI_URL).trim()) ||
  'https://220-km.com:9220';

/** B2B deep-link sections that now live on Open EMS /marketplace. */
export const B2B_SECTIONS_FORWARD_TO_OPEN_EMS_MARKETPLACE = new Set(['marketplace']);

export function openEmsMarketplaceUrl(searchParams) {
  const base = `${OPEN_EMS_UI_URL.replace(/\/$/, '')}/marketplace`;
  if (!searchParams) return base;

  const forwarded = new URLSearchParams();
  for (const key of ['marketplacePayment', 'marketplaceLocation', 'marketplaceHeatmapPayment', 'lang']) {
    const value = searchParams.get(key);
    if (value) forwarded.set(key, value);
  }
  const qs = forwarded.toString();
  return qs ? `${base}?${qs}` : base;
}
